// extracted by mini-css-extract-plugin
module.exports = {"container":"RecommendedCardNotResults_container__I3xmX","text":"RecommendedCardNotResults_text__lfRjQ","subtext":"RecommendedCardNotResults_subtext___MAbt"};